import { gql } from '@src/__generated__';

export const REMOVE_OBJECT = gql(/* GraphQL */ `
  mutation removeObject($input: mnDeleteObjectInput!) {
    mnDeleteObject(input: $input) {
      clientMutationId
    }
  }
`);
